// Export all types and store-related items
export * from './types';
export * from './actions';

import { createStore, Store } from 'redux';
import { RootState } from './types';

// Mock store for development
export const store: Store<RootState> = createStore((state: RootState = {
  auth: {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null
  },
  customization: {
    isOpen: [],
    defaultId: 'default',
    fontFamily: 'Roboto',
    borderRadius: 12,
    opened: true,
    // Default palette mode matches customizationReducer.ts's initialState.
    // Used to be missing here because the inline RootState type didn't
    // require it; now that the slice is typed from CustomizationState, the
    // field is mandatory.
    navType: 'light'
  }
}, action: any) => state);

// Mock persistor for development
export const persistor = {
  persist: () => Promise.resolve(),
  pause: () => {},
  resume: () => {},
  flush: () => Promise.resolve(),
  purge: () => Promise.resolve(),
  register: () => {},
  getState: () => ({ _persist: { rehydrated: true, version: 1 } }),
  dispatch: () => ({}),
  subscribe: (callback: () => void) => {
    // Mock subscribe function that immediately calls the callback
    callback();
    return () => {}; // Return unsubscribe function
  }
};